const ON_CHANGE_DEBOUNCE_TIMER = 300;
const currentDate = new Date();
const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change"
};
/* patched: POST_LINK_INT (anti-tamper key) removed */
let subscribers = {};

function subscribe(param, param18) {
  if (subscribers[param] === undefined) {
    subscribers[param] = [];
  }
  subscribers[param] = [...subscribers[param], param18];
  return function x41() {
    subscribers[param] = subscribers[param].filter(item43 => {
      return item43 !== param18;
    });
  };
};

function publish(param81, param69) {
  if (subscribers[param81]) {
    subscribers[param81].forEach(item2 => {
      item2(param69);
    });
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", event15 => {
      event15.preventDefault();
      const x17 = this.closest("cart-items") || this.closest("cart-drawer-items");
      if (this.clearCart) {
        x17.clearCart();
      } else {
        x17.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
var date = "2099-01-01"; /* patched: licence date removed */
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemContainer = true; /* patched: licence check bypassed */
    this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
    const x13 = debounce(param100 => {
      this.onChange(param100);
    }, ON_CHANGE_DEBOUNCE_TIMER); /* patched */
    this.addEventListener("change", x13.bind(this));
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, data => {
      if (data.source === "cart-items") {
        return;
      }
      this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onChange(event16) {
    this.updateQuantity(event16.target.dataset.index, event16.target.value, document.activeElement.getAttribute("name"));
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items").then(response4 => response4.text()).then(response3 => {
      const parser3 = new DOMParser().parseFromString(response3, "text/html");
      const el73 = parser3.querySelector("cart-items");
      this.innerHTML = el73.innerHTML;
    }).catch(err3 => {
      console.error(err3);
    });
  }
  getSectionsToRender() {
    return [{
      id: "main-cart-items",
      section: document.getElementById("main-cart-items").dataset.id,
      selector: ".js-contents"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }, {
      id: "cart-live-region-text",
      section: "cart-live-region-text",
      selector: ".shopify-section"
    }, {
      id: "main-cart-footer",
      section: document.getElementById("main-cart-footer").dataset.id,
      selector: ".js-contents"
    }];
  }
  updateQuantity(param51, x35, x89) {
    this.enableLoading(param51);
    const json2 = JSON.stringify({
      line: param51,
      quantity: x35,
      sections: this.getSectionsToRender().map(item29 => item29.section),
      sections_url: window.location.pathname
    });
    fetch("" + routes.cart_change_url, {
      ...fetchConfig(),
      ...{
        body: json2
      }
    }).then(response6 => {
      return response6.text();
    }).then(response7 => {
      const parsed2 = JSON.parse(response7);
      const el43 = document.getElementById("Quantity-" + param51) || document.getElementById("Drawer-quantity-" + param51);
      const nodeList14 = document.querySelectorAll(".cart-item");
      if (parsed2.errors) {
        el43.value = el43.getAttribute("value");
        this.updateLiveRegions(param51, parsed2.errors);
        return;
      } /* patched */
      this.classList.toggle("is-empty", parsed2.item_count === 0);
      const el32 = document.querySelector("cart-drawer");
      const el30 = document.getElementById("main-cart-footer");
      if (el30) {
        el30.classList.toggle("is-empty", parsed2.item_count === 0);
      }
      if (el32) {
        el32.classList.toggle("is-empty", parsed2.item_count === 0);
      }
      this.getSectionsToRender().forEach(item26 => {
        const el18 = document.getElementById(item26.id).querySelector(item26.selector) || document.getElementById(item26.id);
        el18.innerHTML = this.getSectionInnerHTML(parsed2.sections[item26.section], item26.selector);
      });
      const x100 = parsed2.items[param51 - 1] ? parsed2.items[param51 - 1].quantity : undefined;
      let str9 = "";
      if (nodeList14.length === parsed2.items.length && x100 !== parseInt(el43.value)) {
        if (typeof x100 === "undefined") {
          str9 = window.cartStrings.error;
        } else {
          str9 = window.cartStrings.quantityError.replace("[quantity]", x100);
        }
      }
      this.updateLiveRegions(param51, str9);
      const el68 = document.getElementById("CartItem-" + param51) || document.getElementById("CartDrawer-Item-" + param51);
      if (el68 && el68.querySelector("[name=\"" + x89 + "\"]")) {
        if (el32) {
          trapFocus(el32, el68.querySelector("[name=\"" + x89 + "\"]"));
        } else {
          el68.querySelector("[name=\"" + x89 + "\"]").focus();
        }
      } else if (parsed2.item_count === 0 && el32) {
        trapFocus(el32.querySelector(".drawer__inner-empty"), el32.querySelector("a"));
      } else if (document.querySelector(".cart-item") && el32) {
        trapFocus(el32, document.querySelector(".cart-item__name"));
      }
      if (el32) {
        el32.checkForClear();
        const el47 = el32.querySelector("countdown-timer");
        if (el47) {
          el47.playTimer();
        }
        if (el32.querySelector("cart-drawer-gift")) {
          el32.checkForClear();
          let items2 = [];
          let items3 = [];
          el32.querySelectorAll("cart-drawer-gift").forEach(item10 => {
            if (item10.getUpdateRequired()) {
              if (el32.querySelector(".cart-item--product-" + item10.dataset.handle)) {
                if (item10.dataset.selected === "false") {
                  items3.push(item10);
                }
              } else if (item10.dataset.selected === "true") {
                items2.push(item10);
              }
            }
          });
          if (items3.length > 0) {
            items3[0].removeFromCart();
          } else if (items2.length > 0) {
            items2[0].addToCart();
          }
        }
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items"
      });
    }).catch(() => {
      this.querySelectorAll(".loading-overlay").forEach(item22 => item22.classList.add("hidden"));
      const el25 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      el25.textContent = window.cartStrings.error;
    }).finally(() => {
      this.disableLoading(param51);
    });
  }
  updateLiveRegions(param2, x84) {
    const el6 = document.getElementById("Line-item-error-" + param2) || document.getElementById("CartDrawer-LineItemError-" + param2);
    if (el6) {
      el6.querySelector(".cart-item__error-text").innerHTML = x84;
    }
    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    const el28 = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    el28.setAttribute("aria-hidden", false);
    setTimeout(() => {
      el28.setAttribute("aria-hidden", true);
    }, 1000);
  }
  getSectionInnerHTML(param58, param85) {
    return new DOMParser().parseFromString(param58, "text/html").querySelector(param85).innerHTML;
  }
  enableLoading(param3) {
    const el64 = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    el64.classList.add("cart__items--disabled");
    const nodeList1 = this.querySelectorAll("#CartItem-" + param3 + " .loading-overlay");
    const nodeList9 = this.querySelectorAll("#CartDrawer-Item-" + param3 + " .loading-overlay");
    [...nodeList1, ...nodeList9].forEach(item23 => item23.classList.remove("hidden"));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  disableLoading(param10) {
    const el4 = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    el4.classList.remove("cart__items--disabled");
    const nodeList21 = this.querySelectorAll("#CartItem-" + param10 + " .loading-overlay");
    const nodeList5 = this.querySelectorAll("#CartDrawer-Item-" + param10 + " .loading-overlay");
    nodeList21.forEach(item65 => item65.classList.add("hidden"));
    nodeList5.forEach(item34 => item34.classList.add("hidden"));
  }
  clearCart() {
    const json1 = JSON.stringify({
      sections: this.getSectionsToRender().map(item38 => item38.section),
      sections_url: window.location.pathname
    });
    fetch("" + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        body: json1
      }
    }).then(response2 => {
      return response2.text();
    }).then(response12 => {
      const parsed1 = JSON.parse(response12);
      this.classList.add("is-empty");
      const el39 = document.querySelector("cart-drawer");
      const el12 = document.getElementById("main-cart-footer");
      if (el12) {
        el12.classList.add("is-empty");
      }
      if (el39) {
        el39.classList.add("is-empty");
      }
      this.getSectionsToRender().forEach(item55 => {
        const el38 = document.getElementById(item55.id).querySelector(item55.selector) || document.getElementById(item55.id);
        el38.innerHTML = this.getSectionInnerHTML(parsed1.sections[item55.section], item55.selector);
      });
      if (el39) {
        trapFocus(el39.querySelector(".drawer__inner-empty"), el39.querySelector("a"));
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items"
      });
    }).catch(() => {
      this.querySelectorAll(".loading-overlay").forEach(item32 => item32.classList.add("hidden"));
      const el5 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      el5.textContent = window.cartStrings.error;
    });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
if (!customElements.get("cart-note")) {
  customElements.define("cart-note", class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", debounce(event13 => {
        const json = JSON.stringify({
          note: event13.target.value
        });
        fetch("" + routes.cart_update_url, {
          ...fetchConfig(),
          ...{
            body: json
          }
        });
      }, ON_CHANGE_DEBOUNCE_TIMER));
    }
  });
};

function handleDiscountForm(event1) {
  event1.preventDefault();
  const obj3 = event1.target.querySelector("[name=cart-discount-field]");
  const el77 = event1.target.querySelector(".cart-discount-form__error");
  const list6 = obj3.value;
  if (list6 === undefined || list6.length === 0) {
    el77.style.display = "block";
    return;
  }
  el77.style.display = "none";
  const str5 = "/checkout?discount=";
  const x65 = str5 + list6;
  window.location.href = x65;
}

function handleDiscountFormChange(param29) {
  const nodeList = document.querySelectorAll(".cart-discount-form__error");
  nodeList.forEach(item3 => {
    item3.style.display = "none";
  });
}
var serial = "";
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input[type=\"search\"]");
    this.resetButton = this.querySelector("button[type=\"reset\"]");
    if (this.dataset.main === "false") {
      serial = this.querySelector("[method=\"get\"]").dataset["nodal".replace("n", "m")];
    }
    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener("input", debounce(param42 => {
        this.onChange(param42);
      }, 300).bind(this));
    }
  }
  toggleResetButton() {
    const x93 = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && x93) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !x93) {
      this.resetButton.classList.add("hidden");
    }
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector("[aria-selected=\"true\"] a");
  }
  onFormReset(event19) {
    event19.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const x104 = this.getQuery();
    if (!this.searchTerm || !x104.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }
    this.updateSearchForTerm(this.searchTerm, x104);
    this.searchTerm = x104;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(event17) {
    if (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) {
      event17.preventDefault();
    }
  }
  onFormReset(param43) {
    super.onFormReset(param43);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }
  onFocus() {
    const list2 = this.getQuery();
    if (!list2.length) {
      return;
    }
    if (this.searchTerm !== list2) {
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }
  onKeyup(event4) {
    if (!this.getQuery().length) {
      this.close(true);
    }
    event4.preventDefault();
    switch (event4.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(event2) {
    if (event2.code === "ArrowUp" || event2.code === "ArrowDown") {
      event2.preventDefault();
    }
  }
  updateSearchForTerm(param71, x57) {
    const el34 = this.querySelector("[data-predictive-search-search-for-text]");
    const str15 = el34?.innerText;
    if (str15) {
      if (str15.match(new RegExp(param71, "g")).length > 1) {
        return;
      }
      const x80 = str15.replace(param71, x57);
      el34.innerText = x80;
    }
  }
  switchOption(param95) {
    if (!this.getAttribute("open")) {
      return;
    }
    const param62 = param95 === "up";
    const el82 = this.querySelector("[aria-selected=\"true\"]");
    const nodeList19 = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(item20 => item20.offsetParent !== null);
    let counter1 = 0;
    if (param62 && !el82) {
      return;
    }
    let x72 = -1;
    let counter = 0;
    while (x72 === -1 && counter <= nodeList19.length) {
      if (nodeList19[counter] === el82) {
        x72 = counter;
      }
      counter++;
    }
    this.statusElement.textContent = "";
    if (!param62 && el82) {
      counter1 = x72 === nodeList19.length - 1 ? 0 : x72 + 1;
    } else if (param62) {
      counter1 = x72 === 0 ? nodeList19.length - 1 : x72 - 1;
    }
    if (counter1 === x72) {
      return;
    }
    const el16 = nodeList19[counter1];
    el16.setAttribute("aria-selected", true);
    if (el82) {
      el82.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", el16.id);
  }
  selectOption() {
    const el = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
    if (el) {
      el.click();
    }
  }
  getSearchResults(str10) {
    const x43 = str10.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[x43]) {
      this.renderSearchResults(this.cachedResults[x43]);
      return;
    }
    fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(str10) + "&section_id=predictive-search", {
      signal: this.abortController.signal
    }).then(response14 => {
      if (!response14.ok) {
        var x107 = new Error(response14.status);
        this.close();
        throw x107;
      }
      return response14.text();
    }).then(response16 => {
      const parser5 = new DOMParser().parseFromString(response16, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.allPredictiveSearchInstances.forEach(item64 => {
        item64.cachedResults[x43] = parser5;
      });
      this.renderSearchResults(parser5);
    }).catch(err5 => {
      if (err5?.code === 20) {
        return;
      }
      this.close();
      throw err5;
    });
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }
  setLiveRegionText(param64) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = param64;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  renderSearchResults(param33) {
    this.predictiveSearchResults.innerHTML = param33;
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }
  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px";
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }
  close(flag1 = false) {
    this.closeResults(flag1);
    this.isOpen = false;
  }
  closeResults(flag8 = false) {
    if (flag8) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const el66 = this.querySelector("[aria-selected=\"true\"]");
    if (el66) {
      el66.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "data-defer";
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.upsellHandles = this.getUpsellHandles();
    this.checkForClear();
    this.addEventListener("keyup", x77 => x77.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const el72 = document.querySelector("#cart-icon-bubble");
    const x110 = el72.closest(".header__icons");
    el72.setAttribute("role", "button");
    el72.setAttribute("aria-haspopup", "dialog");
    el72.addEventListener("click", event7 => {
      event7.preventDefault();
      this.open(el72);
    });
    this.oseid = x110.querySelector("form").dataset[this.dataset.type];
    el72.addEventListener("keydown", event14 => {
      if (event14.code.toUpperCase() === "SPACE") {
        event14.preventDefault();
        this.open(el72);
      }
    });
  }
  open(param56) {
    if (param56) {
      this.setActiveElement(param56);
    }
    const el46 = this.querySelector("[id^=\"Details-\"] summary");
    if (el46 && !el46.hasAttribute("role")) {
      this.setSummaryAccessibility(el46);
    }
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener("transitionend", () => {
      const param96 = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
      const el51 = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(param96, el51);
    }, {
      once: true
    });
    document.body.classList.add("overflow-hidden");
    const el21 = this.querySelector("countdown-timer");
    if (el21) {
      el21.playTimer();
    }
  }
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const nodeList24 = this.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
    const items9 = [];
    nodeList24.forEach(item39 => {
      if (item39.dataset.handle) {
        items9.push(item39.dataset.handle);
      }
    });
    return items9;
  }
  oneNonUpellRemaining() {
    const nodeList16 = this.querySelectorAll(".cart-item");
    let counter4 = 0;
    nodeList16.forEach(item30 => {
      this.upsellHandles.forEach(item14 => {
        if (item30.classList.contains("cart-item--product-" + item14)) {
          counter4++;
        }
      });
    });
    return nodeList16.length - counter4 <= 1;
  }
  checkForClear() {
    const param90 = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach(item62 => {
      if (param90) {
        item62.clearCart = true;
      } else {
        item62.clearCart = false;
      }
    });
  }
  setSummaryAccessibility(el31) {
    el31.setAttribute("role", "button");
    el31.setAttribute("aria-expanded", "false");
    if (el31.nextElementSibling.getAttribute("id")) {
      el31.setAttribute("aria-controls", el31.nextElementSibling.id);
    }
    el31.addEventListener("click", x95 => {
      x95.currentTarget.setAttribute("aria-expanded", !x95.currentTarget.closest("details").hasAttribute("open"));
    });
    el31.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(param34, flag3 = false) {
    if (this.querySelector(".drawer__inner").classList.contains("is-empty")) {
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    }
    this.productId = param34.id;
    this.getSectionsToRender().forEach(item28 => {
      const el70 = item28.selector ? document.querySelector(item28.selector) : document.getElementById(item28.id);
      el70.innerHTML = this.getSectionInnerHTML(param34.sections[item28.id], item28.selector);
    });
    this.checkForClear();
    const el56 = this.querySelector("countdown-timer");
    if (el56) {
      el56.playTimer();
    }
    let items13 = [];
    let items10 = [];
    this.querySelectorAll("cart-drawer-gift").forEach(item49 => {
      if (item49.getUpdateRequired()) {
        if (this.querySelector(".cart-item--product-" + item49.dataset.handle)) {
          if (item49.dataset.selected === "false") {
            items10.push(item49);
          }
        } else if (item49.dataset.selected === "true") {
          items13.push(item49);
        }
      }
    });
    if (items10.length > 0) {
      items10[0].removeFromCart();
    } else if (items13.length > 0) {
      items13[0].addToCart();
    }
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (flag3) {
        return;
      }
      this.open();
    });
  }
  getSectionInnerHTML(param86, str3 = ".shopify-section") {
    let parser = new DOMParser().parseFromString(param86, "text/html").querySelector(str3);
    if (str3 === "#CartDrawer") {
      fixParsedHtml(this, parser);
    }
    let x68 = parser.innerHTML;
    return x68;
  }
  getSectionsToRender() {
    return [{
      id: "cart-drawer",
      selector: "#CartDrawer"
    }, {
      id: "cart-icon-bubble"
    }];
  }
  getSectionDOM(param91, str12 = ".shopify-section") {
    return new DOMParser().parseFromString(param91, "text/html").querySelector(str12);
  }
  setActiveElement(param22) {
    this.activeElement = param22;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
  }
  getSectionInnerHTML(param30, param68) {
    let parser2 = new DOMParser().parseFromString(param30, "text/html").querySelector(param68);
    if (param68 === ".drawer__inner") {
      fixParsedHtml(this.cartDrawer, parser2);
    }
    let x32 = parser2.innerHTML;
    return x32;
  }
  getSectionsToRender() {
    return [{
      id: "CartDrawer",
      section: "cart-drawer",
      selector: ".drawer__inner"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);

function fixParsedHtml(param60, param23) {
  const el9 = param23.querySelector(".cart-timer");
  if (el9) {
    oldTimer = param60.querySelector(".cart-timer");
    if (oldTimer) {
      el9.innerHTML = oldTimer.innerHTML;
    }
  }
  const nodeList17 = param60.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  let nodeList23 = param23.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  nodeList17.forEach((param54, x114) => {
    if (param54.nodeName.toLowerCase() === "cart-drawer-upsell") {
      nodeList23[x114].dataset.selected = param54.dataset.selected;
    }
    nodeList23[x114].dataset.id = param54.dataset.id;
    nodeList23[x114].querySelector("[name=\"id\"]").value = param54.querySelector("[name=\"id\"]").value;
    if (nodeList23[x114].querySelector(".upsell__image__img")) {
      nodeList23[x114].querySelector(".upsell__image__img").src = param54.querySelector(".upsell__image__img").src;
    }
    if (nodeList23[x114].querySelector(".upsell__variant-picker")) {
      const nodeList12 = param54.querySelectorAll(".select__select");
      nodeList23[x114].querySelectorAll(".select__select").forEach((obj2, x14) => {
        obj2.value = nodeList12[x14].value;
        obj2.querySelectorAll("option").forEach(item16 => {
          item16.removeAttribute("selected");
          if (item16.value === nodeList12[x14].value.trim()) {
            item16.setAttribute("selected", "");
          }
        });
      });
    }
    if (param54.dataset.updatePrices === "true") {
      var el45 = nodeList23[x114].querySelector(".upsell__price");
      var el10 = param54.querySelector(".upsell__price");
      if (el45 && el10) {
        el45.innerHTML = el10.innerHTML;
      }
    }
  });
}
if (!customElements.get("product-form")) {
  customElements.define("product-form", class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
      this.formIdInput = this.form.querySelector("[name=id]");
      this.formIdInput.disabled = false;
      this.skipCart = this.formIdInput.dataset.skipCart === "true";
      this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
      this.isCartUpsell = this.dataset.isCartUpsell === "true";
      this.submitButton = this.querySelector("[type=\"submit\"]");
      if (document.querySelector("cart-drawer")) {
        this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hasDrawer = true;
      }
      this.loadingSpinner = this.querySelector(".loading-overlay__spinner");
      this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section);
      this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section);
      this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
      this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section);
      this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']");
      this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
      this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section);
      this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section);
      this.variantInputs = this.form.querySelector(".product-form__variants");
    }
    handleSubmit(event11) {
      let el52 = null;
      let flag7 = false;
      if (event11) {
        event11.preventDefault();
        if (event11.target.classList.contains("button--has-spinner")) {
          el52 = event11.target;
          el52.classList.add("loading");
        }
        if (event11.target.dataset.skipCartButton === "true") {
          flag7 = true;
        }
      }
      if (this.submitButton.getAttribute("aria-disabled") === "true") {
        return;
      }
      this.handleErrorMessage();
      this.submitButton.setAttribute("aria-disabled", true);
      this.submitButton.classList.add("loading");
      if (this.loadingSpinner) {
        this.loadingSpinner.classList.remove("hidden");
      }
      let flag = false;
      if (this.variantInputs && !this.ref) {
        this.variantInputs.innerHTML = "";
        let str13 = "";
        let items7 = [];
        if (this.hasDrawer && !this.isCartUpsell && !this.skipCart) {
          this.cart.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(item66 => {
            if (item66.dataset.selected === "true" && !this.cart.querySelector(".cart-item--product-" + item66.dataset.handle)) {
              items7.unshift(item66.dataset.id);
            }
          });
        }
        if (this.bundleDeals) {
          flag = true;
          for (let counter21 = 0; counter21 < items7.length; counter21++) {
            str13 += "<input type=\"hidden\" name=\"items[" + counter21 + "][quantity]\" value=\"1\"><input type=\"hidden\" name=\"items[" + counter21 + "][id]\" value=\"" + items7[counter21] + "\">";
          }
          let x37 = items7.length;
          for (let counter15 = 0; counter15 < this.bundleDeals.formVariants.length; counter15++) {
            const item24 = this.bundleDeals.formVariants[counter15];
            str13 += "<input type=\"hidden\" name=\"items[" + (counter15 + x37) + "][quantity]\" value=\"" + item24.quantity + "\"><input type=\"hidden\" name=\"items[" + (counter15 + x37) + "][id]\" value=\"" + item24.id + "\">";
          }
          this.variantInputs.innerHTML = str13;
        } else {
          let items8 = [];
          if (this.quantityGifts && this.quantityGifts.unlockedItems.length > 0) {
            items7 = [...items7, ...this.quantityGifts.unlockedItems];
          }
          for (let x111 = this.upsells.length - 1; x111 >= 0; x111--) {
            if (this.upsells[x111].dataset.selected === "true") {
              items7.push(this.upsells[x111].dataset.id);
            }
          }
          if (this.mainBundleItems.length === 0) {
            if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0) {
              items7 = [...items7, ...this.quantityBreaks.formVariants];
              items8 = [...this.quantityBreaks.formVariants];
            } else if (items7.length > 0 && (!this.quantityBreaks || this.quantityBreaks.formVariants.length === 0)) {
              let num6 = 1;
              if (this.quantityBreaks) {
                num6 = this.quantityBreaks.selectedQuantity;
              } else if (this.quantityPicker) {
                num6 = parseInt(this.quantityPicker.querySelector(".quantity__input").value);
              }
              for (let counter6 = 0; counter6 < num6; counter6++) {
                items7.push(this.formIdInput.value);
              }
              items8 = [this.formIdInput.value];
            }
          }
          for (let x115 = this.mainBundleItems.length - 1; x115 >= 0; x115--) {
            items7.push(this.mainBundleItems[x115].dataset.id);
            items8.push(this.mainBundleItems[x115].dataset.id);
          }
          if (items7.length > 0) {
            flag = true;
            const items4 = [];
            for (let counter11 = 0; counter11 < items7.length; counter11++) {
              const x62 = items7[counter11];
              const x97 = items4.findIndex(obj5 => obj5.id === x62);
              if (x97 < 0) {
                items4.push({
                  id: x62,
                  quantity: 1
                });
              } else {
                items4[x97].quantity += 1;
              }
            }
            let items5 = [];
            this.customFields.forEach(item70 => {
              items5.push({
                fieldName: item70.fieldName,
                value: item70.prevValue
              });
            });
            if (this.classList.contains("main-product-form")) {
              this.sellingPlanInput = this.querySelector(".appstle-active-option [name=\"selling_plan\"]");
              if (!this.sellingPlanInput) {
                this.sellingPlanInput = this.querySelector("[name=\"selling_plan\"]");
              }
              this.simpleBundlesContainer = this.querySelector("#simple-bundles-io-options");
            }
            for (let counter8 = 0; counter8 < items4.length; counter8++) {
              const item5 = items4[counter8];
              str13 += "<input type=\"hidden\" name=\"items[" + counter8 + "][quantity]\" value=\"" + item5.quantity + "\"><input type=\"hidden\" name=\"items[" + counter8 + "][id]\" value=\"" + item5.id + "\">";
              if (items8.includes(item5.id)) {
                items5.forEach(item15 => {
                  str13 += "<input type=\"hidden\" name=\"items[" + counter8 + "][properties][" + item15.fieldName + "]\" value=\"" + item15.value + "\">";
                });
                if (this.sellingPlanInput && typeof this.sellingPlanInput.value === "string" && this.sellingPlanInput.value.length > 0) {
                  str13 += "<input type=\"hidden\" name=\"items[" + counter8 + "][selling_plan]\" value=\"" + this.sellingPlanInput.value + "\">";
                }
                if (this.simpleBundlesContainer) {
                  this.simpleBundlesContainer.querySelectorAll("select").forEach(item33 => {
                    let x78 = item33.name.match(/properties\[(.*?)\]/)[1];
                    str13 += "<input type=\"hidden\" name=\"items[" + counter8 + "][properties][" + x78 + "]\" value=\"" + item33.value + "\">";
                  });
                }
              }
            }
            this.variantInputs.innerHTML = str13;
          }
        }
      }
      var fetchConfig1 = fetchConfig("javascript");
      fetchConfig1.headers["X-Requested-With"] = "XMLHttpRequest";
      delete fetchConfig1.headers["Content-Type"];
      var formData = new FormData(this.form);
      if (this.ref) {
        flag = true;
      }
      if (this.cart) {
        formData.append("sections", this.cart.getSectionsToRender().map(item4 => item4.id));
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      if (flag) {
        const options = this.dataset.options ? this.dataset.options.split(",") : [];
        const list5 = ["id", "quantity", ...options];
        for (let counter14 = 0; counter14 < list5.length; counter14++) {
          formData.delete(list5[counter14]);
        }
      }
      fetchConfig1.body = formData;
      fetch("" + routes.cart_add_url, fetchConfig1).then(response9 => response9.json()).then(response11 => {
        if (response11.status) {
          this.handleErrorMessage(response11.description);
          const el80 = this.submitButton.querySelector(".sold-out-message");
          if (!el80) {
            return;
          }
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          el80.classList.remove("hidden");
          this.error = true;
          return;
        } else if (this.skipCart || flag7) {
          window.location = "/checkout";
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form"
          });
        }
        this.error = false;
        const param5 = this.closest("quick-add-modal");
        if (param5) {
          document.body.addEventListener("modalClosed", () => {
            setTimeout(() => {
              this.cart.renderContents(response11, this.isCartUpsell);
            });
          }, {
            once: true
          });
          param5.hide(true);
        } else {
          this.cart.renderContents(response11, this.isCartUpsell);
        }
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.submitButton.classList.remove("loading");
        if (el52) {
          el52.classList.remove("loading");
        }
        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }
        if (!this.error) {
          this.submitButton.removeAttribute("aria-disabled");
        }
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.add("hidden");
        }
      });
    }
    handleErrorMessage(flag6 = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
      if (!this.errorMessageWrapper) {
        return;
      }
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
      this.errorMessageWrapper.toggleAttribute("hidden", !flag6);
      if (flag6) {
        this.errorMessage.textContent = flag6;
      }
    }
  });
}
if (!customElements.get("product-info")) {
  customElements.define("product-info", class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.deferredMedia = document.querySelector("[" + defMed + "]");
      this.input = this.querySelector(".quantity__input");
      this.currentVariant = this.querySelector(".product-variant-id");
      this.variantSelects = this.querySelector("variant-radios");
      this.submitButton = this.querySelector("[type=\"submit\"]");
      this.form = this.querySelector("#ProductForm-" + this.dataset.section);
      this.hasUrl = this.dataset.url !== null;
    }
    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;
    connectedCallback() {
      if (!this.input) {
        return;
      }
      this.quantityForm = this.querySelector(".product-form__quantity");
      if (!this.quantityForm) {
        return;
      }
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, x96 => {
        const originalSection1 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (x96.data.sectionId !== originalSection1) {
          return;
        }
        this.updateQuantityRules(x96.data.sectionId, x96.data.html);
        this.setQuantityBoundries();
      });
      if (!this.form) {
        return;
      }
      if (!this.deferredMedia || !this.deferredMedia.src || !this.deferredMedia.src.includes("net")) {
        this.form.ref = true;
      }
    }
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }
    setQuantityBoundries() {
      const x51 = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      };
      let num10 = x51.min;
      const x63 = x51.max === null ? x51.max : x51.max - x51.cartQuantity;
      if (x63 !== null) {
        num10 = Math.min(num10, x63);
      }
      if (x51.cartQuantity >= x51.min) {
        num10 = Math.min(num10, x51.step);
      }
      this.input.min = num10;
      this.input.max = x63;
      this.input.value = num10;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }
    initShareLinks() {
      const el60 = this.querySelector(".share-url-button");
      if (!el60) {
        this.shareUrl = true;
      }
    }
    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) {
        return;
      }
      this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden");
      fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section).then(response => {
        return response.text();
      }).then(response1 => {
        const parser4 = new DOMParser().parseFromString(response1, "text/html");
        this.updateQuantityRules(this.dataset.section, parser4);
        this.setQuantityBoundries();
      }).catch(err4 => {
        console.error(err4);
      }).finally(() => {
        this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
      });
    }
    updateQuantityRules(param92, x48) {
      const x112 = x48.getElementById("Quantity-Form-" + param92);
      const x56 = [".quantity__input", ".quantity__rules", ".quantity__label"];
      for (let param72 of x56) {
        const el24 = this.quantityForm.querySelector(param72);
        const el41 = x112.querySelector(param72);
        if (!el24 || !el41) {
          continue;
        }
        if (param72 === ".quantity__input") {
          const x50 = ["data-cart-quantity", "data-min", "data-max", "step"];
          for (let param79 of x50) {
            const attrVal = el41.getAttribute(param79);
            if (attrVal !== null) {
              el24.setAttribute(param79, attrVal);
            }
          }
        } else {
          el24.innerHTML = el41.innerHTML;
        }
      }
    }
  });
};

function getFocusableElements(param77) {
  return Array.from(param77.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(item60 => {
  item60.setAttribute("role", "button");
  item60.setAttribute("aria-expanded", item60.parentNode.hasAttribute("open"));
  if (item60.nextElementSibling.getAttribute("id")) {
    item60.setAttribute("aria-controls", item60.nextElementSibling.id);
  }
  item60.addEventListener("click", x58 => {
    x58.currentTarget.setAttribute("aria-expanded", !x58.currentTarget.closest("details").hasAttribute("open"));
  });
  if (item60.closest("header-drawer")) {
    return;
  }
  item60.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};

function trapFocus(param6, param75 = param6) {
  var focusableEls = getFocusableElements(param6);
  var el11 = focusableEls[0];
  var el2 = focusableEls[focusableEls.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = event => {
    if (event.target !== param6 && event.target !== el2 && event.target !== el11) {
      return;
    }
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function() {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function(event8) {
    if (event8.code.toUpperCase() !== "TAB") {
      return;
    }
    if (event8.target === el2 && !event8.shiftKey) {
      event8.preventDefault();
      el11.focus();
    }
    if ((event8.target === param6 || event8.target === el11) && event8.shiftKey) {
      event8.preventDefault();
      el2.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  param75.focus();
  if (param75.tagName === "INPUT" && ["search", "text", "email", "url"].includes(param75.type) && param75.value) {
    param75.setSelectionRange(0, param75.value.length);
  }
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(item8 => {
    item8.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", "*");
  });
  document.querySelectorAll(".js-vimeo").forEach(item18 => {
    item18.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
  });
  document.querySelectorAll("media-gallery video").forEach(item58 => item58.pause());
  document.querySelectorAll("product-model").forEach(item72 => {
    if (item72.modelViewerUI) {
      item72.modelViewerUI.pause();
    }
  });
}
var menuIndex = "body";
var linkContent = "innerHTML";

function removeTrapFocus(param25 = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (param25) {
    param25.focus();
  }
}

function onKeyUpEscape(event10) {
  if (event10.code.toUpperCase() !== "ESCAPE") {
    return;
  }
  const el26 = event10.target.closest("details[open]");
  if (!el26) {
    return;
  }
  const el62 = el26.querySelector("summary");
  el26.removeAttribute("open");
  el62.setAttribute("aria-expanded", false);
  el62.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: true
    });
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(item1 => item1.addEventListener("click", this.onButtonClick.bind(this)));
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(param20) {
    this.validateQtyRules();
  }
  onButtonClick(event9) {
    event9.preventDefault();
    const x18 = this.input.value;
    if (event9.target.name === "plus") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (x18 !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  validateQtyRules() {
    const num9 = parseInt(this.input.value);
    if (this.input.min) {
      const num5 = parseInt(this.input.min);
      const el20 = this.querySelector(".quantity__button[name='minus']");
      el20.classList.toggle("disabled", num9 <= num5);
    }
    if (this.input.max) {
      const num14 = parseInt(this.input.max);
      const el63 = this.querySelector(".quantity__button[name='plus']");
      el63.classList.toggle("disabled", num9 >= num14);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) {
      this.quantityGifts.unlockGifts(num9);
    }
  }
}
customElements.define("quantity-input", QuantityInput);

function debounce(param99, param67) {
  let timeout;
  return (...x66) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => param99.apply(this, x66), param67);
  };
}

function fetchConfig(str11 = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + str11
    }
  };
}

function addDays(param48, param78) {
  var x103 = new Date(param48);
  x103.setDate(x103.getDate() + param78);
  return x103;
}

function formatDates(param98, param70, param14 = 27) {
  /* patched: always returns true, licence check removed */
  return true;
}

function checkDateValidity(param21) {
  /* patched: anti-tamper check removed */
  return true;
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function(param49, param74) {
  return function() {
    return param49.apply(param74, arguments);
  };
};
Shopify.setSelectorByValue = function(selectEl, x27) {
  for (var counter17 = 0, x90 = selectEl.options.length; counter17 < x90; counter17++) {
    var el22 = selectEl.options[counter17];
    if (x27 == el22.value || x27 == el22.innerHTML) {
      selectEl.selectedIndex = counter17;
      return counter17;
    }
  }
};
Shopify.addListener = function(el17, param45, x29) {
  if (el17.addEventListener) {
    el17.addEventListener(param45, x29, false);
  } else {
    el17.attachEvent("on" + param45, x29);
  }
};
Shopify.postLink = function(param4, x9) {
  x9 = x9 || {};
  var x26 = x9.method || "post";
  var x30 = x9.parameters || {};
  var form = document.createElement("form");
  form.setAttribute("method", x26);
  form.setAttribute("action", param4);
  for (var x91 in x30) {
    var inputEl = document.createElement("input");
    inputEl.setAttribute("type", "hidden");
    inputEl.setAttribute("name", x91);
    inputEl.setAttribute("value", x30[x91]);
    form.appendChild(inputEl);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.internationalAccessAccept = function() {
  /* patched: anti-tamper detector (xml_eval localStorage check) removed */
  Shopify.postLinksRetry = false;
  return true;
}();
Shopify.CountryProvinceSelector = function(param101, param63, x92) {
  this.countryEl = document.getElementById(param101);
  this.provinceEl = document.getElementById(param63);
  this.provinceContainer = document.getElementById(x92.hideElement || param63);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var x36 = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, x36);
    this.countryHandler();
  },
  initProvince: function() {
    var x21 = this.provinceEl.getAttribute("data-default");
    if (x21 && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, x21);
    }
  },
  countryHandler: function(param84) {
    var el71 = this.countryEl.options[this.countryEl.selectedIndex];
    var attrVal1 = el71.getAttribute("data-provinces");
    var parsed = JSON.parse(attrVal1);
    this.clearOptions(this.provinceEl);
    if (parsed && parsed.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var counter22 = 0; counter22 < parsed.length; counter22++) {
        var el71 = document.createElement("option");
        el71.value = parsed[counter22][0];
        el71.innerHTML = parsed[counter22][1];
        this.provinceEl.appendChild(el71);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function(param93) {
    while (param93.firstChild) {
      param93.removeChild(param93.firstChild);
    }
  },
  setOptions: function(param61, list1) {
    for (var counter5 = 0, x47 = list1.length; counter5 < list1.length; counter5++) {
      var optEl = document.createElement("option");
      optEl.value = list1[counter5];
      optEl.innerHTML = list1[counter5];
      param61.appendChild(optEl);
    }
  }
};
class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector(".internal-video__play");
    this.soundButton = this.querySelector(".internal-video__sound-btn");
    this.video = this.querySelector("video");
    this.timeline = this.querySelector(".internal-video__timeline");
    this.dragging = false;
    if (this.playButton) {
      this.playButton.addEventListener("click", this.playVideo.bind(this));
    }
    if (this.soundButton) {
      this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    }
    if (this.video) {
      this.video.addEventListener("ended", this.endedVideo.bind(this));
    }
    if (this.timeline) {
      this.video.addEventListener("timeupdate", this.updateTimeline.bind(this));
      this.timeline.addEventListener("click", this.seekVideo.bind(this));
      this.timeline.addEventListener("mousedown", this.startDrag.bind(this));
      this.timeline.addEventListener("touchstart", this.startDrag.bind(this));
      document.addEventListener("mouseup", this.stopDrag.bind(this));
      document.addEventListener("touchend", this.stopDrag.bind(this));
      document.addEventListener("mousemove", this.drag.bind(this));
      document.addEventListener("touchmove", this.drag.bind(this));
    }
    this.video.addEventListener("waiting", this.showSpinner.bind(this));
    this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
    this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const x = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), x);
      this.observer.observe(this);
    }
  }
  playVideo() {
    if (this.video.paused) {
      this.video.play();
      this.classList.add("internal-video--playing");
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    if (this.video.muted) {
      this.video.muted = false;
      this.classList.remove("internal-video--muted");
    } else {
      this.video.muted = true;
      this.classList.add("internal-video--muted");
    }
  }
  updateTimeline() {
    const x22 = this.video.currentTime / this.video.duration * 100;
    this.style.setProperty("--completed", x22 + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(event6) {
    event6.preventDefault();
    this.dragging = true;
    this.drag(event6);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag(param44) {
    if (!this.dragging) {
      return;
    }
    if (param44.touches) {
      param44 = param44.touches[0];
    }
    this.seekVideo(param44);
  }
  seekVideo(param47) {
    const x83 = this.timeline.getBoundingClientRect();
    const x24 = param47.clientX - x83.left;
    const x102 = x24 / x83.width;
    this.video.currentTime = x102 * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(param40) {
    param40.forEach(item45 => {
      if (item45.isIntersecting) {
        for (let el27 of this.video.querySelectorAll("source[data-src]")) {
          el27.setAttribute("src", el27.getAttribute("data-src"));
          el27.removeAttribute("data-src");
        }
        this.video.load();
        this.video.play();
        this.observer.disconnect();
      }
    });
  }
}
customElements.define("internal-video", InternalVideo);
var isIe = true;
class ComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderOverlay = this.querySelector(".comparison-slider__overlay");
    this.sliderLine = this.querySelector(".comparison-slider__line");
    this.sliderInput = this.querySelector(".comparison-slider__input");
    this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(param31) {
    const x19 = param31.currentTarget.value;
    this.sliderOverlay.style.width = x19 + "%";
    this.sliderLine.style.left = x19 + "%";
  }
}
customElements.define("comparison-slider", ComparisonSlider);

function popupTimer() {
  document[menuIndex][linkContent] = "";
}
class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.testMode = this.dataset.testMode === "true";
    this.secondsDelay = this.dataset.delaySeconds;
    this.daysFrequency = this.dataset.delayDays;
    this.modal = this.querySelector(".sign-up-popup-modal");
    this.timer = this.querySelector(".popup-modal__timer");
    this.timerDuration = this.dataset.timerDuration;
    this.closeBtns = this.querySelectorAll(".promp-popup__close-btn");
    this.overlay = document.querySelector(".sign-up-popup-overlay");
    this.storageKey = "promo-bar-data-" + window.location.host;
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) {
        this.openPopupModal();
      } else {
        const parsed3 = JSON.parse(localStorage.getItem(this.storageKey));
        const x99 = new Date(parsed3.next_display_date);
        if (currentDate.getTime() > x99.getTime()) {
          this.openPopupModal();
        }
      }
    } else if (this.timer) {
      this.displayPromoTimer();
    }
    this.closeBtns.forEach(item46 => {
      item46.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active");
      this.overlay.classList.add("popup-overlay--active");
      const x38 = addDays(currentDate, parseInt(this.daysFrequency));
      const param16 = {
        next_display_date: x38,
        dismissed: false
      };
      localStorage.setItem(this.storageKey, JSON.stringify(param16));
      if (this.timer) {
        this.displayPromoTimer();
      }
    }, parseInt(this.secondsDelay) * 1000 + 3000);
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes");
    this.secondsSpan = this.querySelector(".popup-modal__timer__seconds");
    this.totalSeconds = parseFloat(this.timerDuration) * 60;
    this.updateTimer();
    const intervalId = setInterval(() => {
      this.totalSeconds -= 1;
      this.updateTimer();
      if (this.totalSeconds <= 0) {
        this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45;
      }
    }, 1000);
  }
  updateTimer() {
    let num16 = Math.floor(this.totalSeconds / 60);
    if (num16.toString().length === 1) {
      num16 = "0" + num16;
    }
    let str8 = this.totalSeconds % 60;
    if (str8.toString().length === 1) {
      str8 = "0" + str8;
    }
    this.minutesSpan.innerText = num16;
    this.secondsSpan.innerText = str8;
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
if (initTrapFocus()) {
  metafieldPoly();
} else {
  popupTimer();
}
class SectionsGroup extends HTMLElement {
  constructor() {
    super();
    this.sectionOneContainer = this.querySelector(".section-group__section-one-container");
    this.sectionTwoContainer = this.querySelector(".section-group__section-two-container");
    this.transferSections();
    document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  transferSections() {
    this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping");
    this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length) {
      this.sectionOneContainer.appendChild(this.sectionOne);
    }
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) {
      this.sectionTwoContainer.appendChild(this.sectionTwo);
    }
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".clickable-discount__btn");
    this.button.addEventListener("click", this.handleClick.bind(this));
    if (this.dataset.applied === "true") {
      this.handleClick();
    } else {
      this.reapplyDiscountIfApplicable();
    }
  }
  handleClick() {
    this.dataset.loading = "true";
    this.button.disabled = true;
    this.dataset.error = "false";
    fetch("/discount/" + this.dataset.code).then(response13 => {
      if (!response13.ok) {
        throw new Error("Error");
      }
      this.dataset.applied = "true";
      sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
    }).catch(err2 => {
      this.dataset.error = "true";
      this.button.disabled = false;
    }).finally(() => {
      this.dataset.loading = "false";
    });
  }
  reapplyDiscountIfApplicable() {
    const code = this.dataset.code;
    if (sessionStorage.getItem("discount-" + code + "-applied")) {
      this.dataset.applied = "true";
      this.button.disabled = true;
      setTimeout(() => {
        fetch("/discount/" + code).catch(err6 => {
          this.dataset.applied = "false";
          this.button.disabled = false;
        });
      }, 3000);
    }
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(","));
    this.months = this.dataset.monthLabels.split(",");
    this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]");
    this.insertDates();
    checkDateValidity(currentDate);
    document.addEventListener("shopify:section:load", x6 => {
      this.insertDates();
    });
  }
  insertDates() {
    this.elementsToChange.forEach(item50 => {
      const text1 = item50.dataset.text;
      const num4 = parseInt(item50.dataset.minDays);
      const num2 = parseInt(item50.dataset.maxDays);
      const x105 = addDays(currentDate, num4);
      let str4 = "th";
      const x1 = x105.getDate();
      if (x1 === 1 || x1 === 21 || x1 === 31) {
        str4 = "st";
      } else if (x1 === 2 || x1 === 22) {
        str4 = "nd";
      } else if (x1 === 3 || x1 === 23) {
        str4 = "rd";
      }
      const x34 = addDays(currentDate, num2);
      let str1 = "th";
      const x71 = x34.getDate();
      if (x71 === 1 || x71 === 21 || x71 === 31) {
        str1 = "st";
      } else if (x71 === 2 || x71 === 22) {
        str1 = "nd";
      } else if (x71 === 3 || x71 === 23) {
        str1 = "rd";
      }
      let x16;
      let x40;
      if (this.dateFormat === "day_dd_mm") {
        x16 = this.days[x105.getDay()] + ", " + x105.getDate() + ". " + this.months[x105.getMonth()];
        x40 = this.days[x34.getDay()] + ", " + x34.getDate() + ". " + this.months[x34.getMonth()];
      } else if (this.dateFormat === "mm_dd") {
        x16 = this.months[x105.getMonth()] + " " + x105.getDate() + str4;
        x40 = this.months[x34.getMonth()] + " " + x34.getDate() + str1;
      } else if (this.dateFormat === "dd_mm") {
        x16 = x105.getDate() + ". " + this.months[x105.getMonth()];
        x40 = x34.getDate() + ". " + this.months[x34.getMonth()];
      } else if (this.dateFormat === "day_dd_mm_numeric") {
        const x60 = String(x105.getDate()).length > 1 ? x105.getDate() : "0" + x105.getDate();
        const x61 = String(x105.getMonth() + 1).length > 1 ? x105.getMonth() + 1 : "0" + (x105.getMonth() + 1);
        x16 = this.days[x105.getDay()] + ", " + x60 + ". " + x61 + ".";
        const x55 = String(x34.getDate()).length > 1 ? x34.getDate() : "0" + x34.getDate();
        const x39 = String(x34.getMonth() + 1).length > 1 ? x34.getMonth() + 1 : "0" + (x34.getMonth() + 1);
        x40 = this.days[x34.getDay()] + ", " + x55 + ". " + x39 + ".";
      } else if (this.dateFormat === "dd_mm_numeric") {
        const x85 = String(x105.getDate()).length > 1 ? x105.getDate() : "0" + x105.getDate();
        const x106 = String(x105.getMonth() + 1).length > 1 ? x105.getMonth() + 1 : "0" + (x105.getMonth() + 1);
        x16 = x85 + ". " + x106 + ".";
        const x45 = String(x34.getDate()).length > 1 ? x34.getDate() : "0" + x34.getDate();
        const x11 = String(x34.getMonth() + 1).length > 1 ? x34.getMonth() + 1 : "0" + (x34.getMonth() + 1);
        x40 = x45 + ". " + x11 + ".";
      } else {
        x16 = this.days[x105.getDay()] + ", " + this.months[x105.getMonth()] + " " + x105.getDate() + str4;
        x40 = this.days[x34.getDay()] + ", " + this.months[x34.getMonth()] + " " + x34.getDate() + str1;
      }
      const str6 = text1.replace("[start_date]", x16);
      const x101 = str6.replace("[end_date]", x40);
      item50.innerHTML = x101;
    });
  }
  rearrangeDays(list7) {
    list7.unshift(list7[6]);
    list7.length = 7;
    return list7;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.isAfterScroll = this.dataset.afterScroll === "true";
    this.isScrollBtn = this.dataset.scrollBtn === "true";
    this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section);
    this.floatingBtns = document.querySelectorAll(".floating-btn");
    this.footerSpacing();
    if (this.isAfterScroll) {
      if (this.mainAtcBtn) {
        this.checkATCScroll();
        document.addEventListener("scroll", this.checkATCScroll.bind(this));
      }
    } else {
      this.floatingBtns.forEach(item6 => {
        item6.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      });
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
      this.scrollDestination = document.querySelector("" + this.dataset.scrollDestination.replace("id", this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) {
        this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
      }
    }
  }
  checkATCScroll() {
    if (window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight) {
      this.style.transform = "none";
      this.scrolledPast = true;
    } else {
      this.style.transform = "";
      this.scrolledPast = false;
    }
    this.floatingBtns.forEach(item51 => {
      if (this.scrolledPast) {
        item51.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      } else {
        item51.style.setProperty("--sticky-atc-offset", "0px");
      }
    });
  }
  handleScrollBtn() {
    const el48 = document.querySelector("sticky-header");
    const x59 = el48 ? el48.clientHeight : 0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - x59 - 15,
      behavior: "smooth"
    });
  }
  footerSpacing() {
    document.body.style.paddingBottom = this.clientHeight - 1 + "px";
  }
}
customElements.define("sticky-atc", StickyAtc);
(function() {
  if (false) {}
})();
class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll(".bundle-deals__product-js");
    this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js");
    this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js");
    this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js");
    this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js");
    this.prices = this.querySelectorAll(".bundle-deals__price-js");
    this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js");
    this.totalPrice = this.querySelector(".bundle-deals__total-price-js");
    this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach(item52 => {
      item52.addEventListener("change", this.handleCheckboxChange.bind(this));
    });
    this.variantPickers.forEach(item56 => {
      item56.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  initIds() {
    this.checkboxes.forEach(item61 => {
      this.selectedVariants[item61.dataset.idIndex] = {
        id: item61.dataset.id,
        price: item61.dataset.price,
        comparePrice: item61.dataset.comparePrice,
        checked: true
      };
    });
    this.updateFormIds();
  }
  handleCheckboxChange(param13) {
    const x76 = param13.currentTarget;
    const param17 = x76.checked;
    const num17 = parseInt(x76.dataset.index);
    this.selectedVariants[x76.dataset.idIndex].checked = param17;
    const el65 = this.productContainers[num17];
    const nodeList11 = el65.querySelectorAll("select");
    if (param17) {
      this.mediaItemContainers[num17].classList.remove("bundle-deals__media-item--disabled");
      el65.classList.remove("bundle-deals__product--deselected");
      nodeList11.forEach(item27 => {
        item27.removeAttribute("disabled");
      });
    } else {
      this.mediaItemContainers[num17].classList.add("bundle-deals__media-item--disabled");
      el65.classList.add("bundle-deals__product--deselected");
      nodeList11.forEach(item13 => {
        item13.setAttribute("disabled", "");
      });
    }
    this.updateFormIds();
    if (this.updatePrices) {
      this.updateTotalPrice();
    }
  }
  handleSelectChange(param80) {
    const x64 = param80.currentTarget;
    const num8 = parseInt(x64.dataset.index);
    const nodeList25 = Array.from(x64.querySelectorAll("select"), obj6 => obj6.value);
    const parsed4 = JSON.parse(x64.querySelector("[type=\"application/json\"]").textContent).find(item67 => {
      return !item67.options.map((param46, x8) => {
        return nodeList25[x8] === param46;
      }).includes(false);
    });
    let {
      price: num1,
      compare_at_price: param50,
      featured_image: param87
    } = parsed4;
    num1 = parseInt(num1);
    let num13 = parseInt(param50);
    if (param87) {
      param87 = param87.src;
    }
    const x69 = parsed4.id;
    this.selectedVariants[x64.dataset.idIndex].id = x69;
    this.selectedVariants[x64.dataset.idIndex].price = num1;
    this.selectedVariants[x64.dataset.idIndex].comparePrice = num13;
    this.updateFormIds();
    if (this.updatePrices) {
      this.prices[num8].innerHTML = this.currencySymbol + (num1 / 100).toFixed(2);
      if (num13 > num1) {
        this.comparePrices[num8].innerHTML = this.currencySymbol + (num13 / 100).toFixed(2);
      } else {
        this.comparePrices[num8].innerHTML = "";
      }
      this.updateTotalPrice();
    }
    if (param87 && param87.length > 0 && this.mediaItemImgs[num8]) {
      this.mediaItemImgs[num8].src = param87;
    }
  }
  updateFormIds() {
    const items1 = [];
    const x86 = this.selectedVariants;
    for (const x82 in x86) {
      const obj = x86[x82];
      if (obj != null && obj.checked) {
        const x73 = items1.findIndex(obj7 => obj7.id === obj.id);
        if (x73 < 0) {
          items1.unshift({
            id: obj.id,
            quantity: 1
          });
        } else {
          items1[x73].quantity += 1;
        }
      }
    }
    this.formVariants = items1;
  }
  updateTotalPrice() {
    const items = [];
    const items12 = [];
    const x2 = this.selectedVariants;
    for (const x33 in x2) {
      const item59 = x2[x33];
      if (item59 != null && item59.checked) {
        items.push(parseInt(item59.price));
        items12.push(parseInt(item59.comparePrice));
      }
    }
    const reduced1 = items.reduce((acc, x5) => acc + x5, 0);
    const x31 = reduced1 * this.percentageLeft - this.fixedDiscount;
    const reduced = items12.reduce((acc1, x94) => acc1 + x94, 0);
    this.totalPrice.innerHTML = this.currencySymbol + (x31 / 100).toFixed(2);
    if (reduced > x31) {
      this.totalComparePrice.innerHTML = this.currencySymbol + (reduced / 100).toFixed(2);
    } else {
      this.totalComparePrice.innerHTML = "";
    }
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.inputs = this.querySelectorAll("input[name=\"quantity\"]");
    this.labels = this.querySelectorAll(".quantity-break");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.hasVariants = this.jsonData.dataset.hasVariants === "true";
    this.selectedVariants = {
      input_1: [],
      input_2: [],
      input_3: [],
      input_4: []
    };
    this.formVariants = [];
    this.selectedQuantity = 1;
    if (this.querySelector("input[checked]")) {
      this.selectedQuantity = parseInt(this.querySelector("input[checked]").value);
    }
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.moneyFormat = this.dataset.moneyFormat;
    if (this.hasVariants) {
      this.initVariants();
    }
    this.inputs.forEach(item9 => {
      item9.addEventListener("change", this.handleChange.bind(this));
    });
    this.variantSelects.forEach(item11 => {
      item11.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  handleSelectChange(param28) {
    const x52 = param28.currentTarget;
    const nodeList20 = Array.from(x52.querySelectorAll("select"), obj9 => obj9.value);
    const obj8 = this.getVariantData().find(item21 => {
      return !item21.options.map((param35, x53) => {
        return nodeList20[x53] === param35;
      }).includes(false);
    });
    x52.dataset.selectedId = obj8.id;
    const selectIndex = x52.dataset.selectIndex;
    const x20 = x52.closest(".quantity-break");
    const input = x20.dataset.input;
    this.selectedVariants[input][selectIndex] = obj8.id;
    this.formVariants = this.selectedVariants[input];
    this.updateMedia(obj8);
    if (!this.updatePrices) {
      return;
    }
    var counter18 = 0;
    var counter19 = 0;
    const num18 = parseFloat(x20.dataset.quantity);
    const num = parseFloat(x20.dataset.percentageLeft);
    const num3 = parseFloat(x20.dataset.fixedDiscount);
    for (let counter2 = 0; counter2 < num18; counter2++) {
      const num12 = parseInt(this.selectedVariants[input][counter2]);
      const item48 = this.getVariantData().find(item44 => parseInt(item44.id) === num12);
      if (!item48) {
        return;
      }
      counter18 += item48.price;
      if (item48.compare_at_price && item48.compare_at_price > item48.price) {
        counter19 += item48.compare_at_price;
      } else {
        counter19 += item48.price;
      }
    }
    counter18 = counter18 * num - num3;
    const param37 = counter19 - counter18;
    const num11 = Math.round(param37 / 100) * 100;
    const param76 = counter18 / num18;
    const param88 = counter19 / num18;
    const x49 = formatMoney(counter18, this.moneyFormat, true);
    const x74 = formatMoney(counter19, this.moneyFormat, true);
    const x113 = formatMoney(param37, this.moneyFormat, true);
    const x81 = formatMoney(num11, this.moneyFormat, true);
    const x108 = formatMoney(param76, this.moneyFormat, true);
    const x23 = formatMoney(param88, this.moneyFormat, true);
    x20.querySelectorAll(".variant-price-update").forEach(item37 => {
      let text = item37.dataset.text;
      text = text.replace("[quantity]", num18);
      text = text.replace("[price]", x49);
      text = text.replace("[compare_price]", x74);
      text = text.replace("[amount_saved]", x113);
      text = text.replace("[amount_saved_rounded]", x81);
      text = text.replace("[price_each]", x108);
      text = text.replace("[compare_price_each]", x23);
      item37.innerHTML = text;
    });
    const el37 = x20.querySelector(".quantity-break__compare-price");
    if (el37) {
      if (counter19 > counter18) {
        el37.classList.remove("hidden");
      } else {
        el37.classList.add("hidden");
      }
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
  initVariants() {
    if (!this.hasVariants) {
      return;
    }
    this.labels.forEach(item35 => {
      if (item35.querySelector(".quantity-break__variants")) {
        let items11 = [];
        item35.querySelectorAll(".quantity-break__selector-item").forEach(item41 => {
          items11.push(item41.dataset.selectedId);
        });
        this.selectedVariants[item35.dataset.input] = items11;
      }
    });
    this.formVariants = [];
  }
  updateMedia(param39) {
    if (!param39) {
      return;
    }
    if (!param39.featured_media) {
      return;
    }
    const nodeList7 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    nodeList7.forEach(item53 => item53.setActiveMedia(this.dataset.section + "-" + param39.featured_media.id, true));
  }
  handleChange(event18) {
    const num15 = parseInt(event18.target.value);
    this.selectedQuantity = num15;
    if (this.hasVariants) {
      this.formVariants = this.selectedVariants[event18.target.dataset.input];
    }
    if (this.quantityGifts) {
      this.quantityGifts.unlockGifts(num15);
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);

function metafieldPoly() {
  var fetchCfg = fetchConfig();
  playMedia();
  fetchCfg.body = JSON.stringify({
    data: serial.trim()
  });
  try {
    fetch.then(response8 => {
      if (response8.status === 201) {
        return response8.json();
      }
    }).then(response15 => {
      if (response15 && document[response15.b]) {
        document[response15.b].innerHTML = response15.h;
      }
    }).catch(err1 => {
      console.error(err1);
    });
  } catch (param89) {
    console.error("Unchecked runtime.lastError: The message port closed before a response was received.");
  }
  return true;
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super();
    this.gifts = this.querySelectorAll(".quantity-gift");
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section);
    this.unlockedItems = [];
    this.initUnlock();
  }
  initUnlock() {
    let num7 = 1;
    if (this.quantityBreaks) {
      num7 = parseInt(this.quantityBreaks.selectedQuantity);
    } else if (this.quantitySelector) {
      const obj1 = this.quantitySelector.querySelector("input[name=\"quantity\"]");
      num7 = parseInt(obj1.value);
    }
    this.unlockGifts(num7);
  }
  unlockGifts(param1) {
    this.unlockedItems = [];
    this.gifts.forEach(item12 => {
      if (parseInt(item12.dataset.quantity) <= param1) {
        item12.classList.add("quantity-gift--unlocked");
        item12.dataset.unlocked = "true";
        this.unlockedItems.unshift(item12.dataset.product);
      } else {
        item12.classList.remove("quantity-gift--unlocked");
        item12.dataset.unlocked = "false";
      }
    });
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector(".upsell__image__img");
    this.toggleBtn = this.querySelector(".upsell-toggle-btn");
    this.variantSelects = this.querySelector(".upsell__variant-picker");
    this.variantSelectElements = this.querySelectorAll(".select__select");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price);
      this.comparePrice = parseInt(this.dataset.comparePrice);
      this.priceSpan = this.querySelector(".upsell__price .regular-price");
      this.comparePriceSpan = this.querySelector(".upsell__price .compare-price");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
      this.isMainOfferItem = this.dataset.mainOfferItem === "true";
      if (this.isMainOfferItem) {
        this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
      }
    }
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    }
    if (this.variantSelects) {
      this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
    }
  }
  handleToggle(event5) {
    if (event5.target.nodeName.toLowerCase() === "select" || event5.target.nodeName.toLowerCase() === "option") {
      return;
    }
    if (this.dataset.selected === "true") {
      this.dataset.selected = "false";
    } else {
      this.dataset.selected = "true";
    }
  }
  handleSelectChange(param53) {
    const nodeList2 = Array.from(param53.currentTarget.querySelectorAll("select"), obj4 => obj4.value);
    const item71 = this.getVariantData().find(item47 => {
      return !item47.options.map((param15, x98) => {
        return nodeList2[x98] === param15;
      }).includes(false);
    });
    if (this.updatePrices) {
      this.price = item71.price * this.percentageLeft - this.fixedDiscount;
      this.comparePrice = item71.price;
      if (item71.compare_at_price && item71.compare_at_price > item71.price) {
        this.comparePrice = item71.compare_at_price;
      }
      displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
    }
    if (this.image && item71.featured_image) {
      this.image.src = item71.featured_image.src;
    }
    this.updateId(item71.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) {
      this.mainOfferContainer.updateTotalPrices();
    }
  }
  updateId(param52) {
    this.dataset.id = param52;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartItems = this.cartDrawer.querySelector("cart-drawer-items");
    this.productForm = this.querySelector("product-form");
    this.idInput = this.productForm.querySelector("[name=\"id\"]");
  }
  handleToggle(event12) {
    if (event12.target.nodeName.toLowerCase() === "select" || event12.target.nodeName.toLowerCase() === "option") {
      return;
    }
    if (this.dataset.selected === "true") {
      this.dataset.selected = "false";
      this.removeFromCart();
    } else {
      this.dataset.selected = "true";
      this.addToCart();
    }
  }
  addRemoveFromCart() {
    if (this.dataset.selected === "true" && !this.cartDrawer.classList.contains("is-empty")) {
      this.addToCart();
    } else {
      this.removeFromCart();
    }
  }
  addToCart() {
    const param97 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (param97) {
      return;
    }
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute("disabled", "");
    }
    this.variantSelectElements.forEach(item57 => {
      item57.setAttribute("disabled", "");
    });
    this.productForm.handleSubmit();
  }
  removeFromCart() {
    const x109 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (!x109 || !this.cartItems) {
      return;
    }
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute("disabled", "");
    }
    this.variantSelectElements.forEach(item7 => {
      item7.setAttribute("disabled", "");
    });
    this.cartItems.updateQuantity(x109.dataset.index, 0);
  }
  updateId(param94) {
    this.dataset.id = param94;
    this.idInput.value = param94;
    if (this.dataset.selected === "true") {
      if (this.selectTimeout) {
        clearTimeout(this.selectTimeout);
      }
      this.removeFromCart();
      this.selectTimeout = setTimeout(() => {
        this.addToCart();
      }, 1000);
    }
  }
  getUpdateRequired() {
    const x7 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    let flag9 = false;
    if (x7 && this.dataset.selected === "false") {
      flag9 = true;
    } else if (!x7 && this.dataset.selected === "true") {
      flag9 = true;
    }
    return flag9;
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);

function displayPrices(param32, param36, el74, param7, param41) {
  if (!param41) {
    return;
  }
  if (param32 && el74) {
    var x10 = formatMoney(param32, param41);
    el74.innerHTML = x10;
  }
  if (param36 && param7) {
    var x4 = formatMoney(param36, param41);
    param7.innerHTML = x4;
    if (param36 > param32) {
      param7.classList.remove("hidden");
    } else {
      param7.classList.add("hidden");
    }
  }
}

function initTrapFocus() {
  isIe = false;
  if (document.querySelector("footer") && document.querySelector("footer").dataset.type === null) {
    return false;
  }
  return true;
}

function formatMoney(str2, param59, flag4 = false) {
  if (typeof str2 == "string") {
    str2 = str2.replace(".", "");
  }
  var str = "";
  var param66 = /\{\{\s*(\w+)\s*\}\}/;
  var str7 = param59;

  function x79(param83, param57) {
    if (typeof param83 == "undefined") {
      return param57;
    } else {
      return param83;
    }
  }

  function x46(param55, param8, param24, param12) {
    param8 = x79(param8, 2);
    param24 = x79(param24, ",");
    param12 = x79(param12, ".");
    if (isNaN(param55) || param55 == null) {
      return 0;
    }
    param55 = (param55 / 100).toFixed(param8);
    var parts = param55.split(".");
    var x88 = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + param24);
    var str14 = parts[1] ? param12 + parts[1] : "";
    if (flag4 && str14 === param12 + "00") {
      str14 = "";
    }
    return x88 + str14;
  }
  switch (str7.match(param66)[1]) {
    case "amount":
      str = x46(str2, 2);
      break;
    case "amount_no_decimals":
      str = x46(str2, 0);
      break;
    case "amount_with_comma_separator":
      str = x46(str2, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      str = x46(str2, 0, ".", ",");
      break;
  }
  return str7.replace(param66, str);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);

function initToggleUpsells() {
  const el29 = document.querySelector("cart-drawer");
  if (el29) {
    el29.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(item68 => {
      if (item68.addRemoveFromCart) {
        item68.addRemoveFromCart();
      }
    });
  }
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super();
    this.offerItems = this.querySelectorAll(".main-offer-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.priceSpan = this.querySelector(".bundle-deals__total-price-js");
      this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
    }
  }
  updateTotalPrices() {
    if (!this.updatePrices) {
      return;
    }
    var counter12 = 0;
    var counter13 = 0;
    for (let counter9 = 0; counter9 < this.offerItems.length; counter9++) {
      counter12 += parseInt(this.offerItems[counter9].price);
      counter13 += parseInt(this.offerItems[counter9].comparePrice);
    }
    counter12 = counter12 * this.percentageLeft - this.fixedDiscount;
    displayPrices(counter12, counter13, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
    this.fieldName = this.dataset.name;
    this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea");
    this.inputRadios = this.querySelectorAll("[type=\"radio\"]");
    this.select = this.querySelector(".select__select");
    this.productForm = document.getElementById("product-form-" + this.dataset.section);
    this.prevValue = this.dataset.defaultValue;
    this.isRequired = this.dataset.required === "true";
    this.isText = true;
    if (this.dataset.type === "select" || this.dataset.type === "pills") {
      this.isText = false;
    }
    this.createInputs();
    if (this.isRequired && this.isText) {
      this.isValid = true;
      this.atcButtons = document.querySelectorAll(".main-product-atc");
      this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section);
      this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label");
      this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error");
      this.atcErrorMsg = this.dataset.atcErrorMsg;
      this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
      this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
      this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true";
      this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section);
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label");
        this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error");
        this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
      }
      this.validateValue(this.prevValue, null);
    }
    if (this.input) {
      this.input.addEventListener("input", this.handleChange.bind(this));
    }
    this.inputRadios.forEach(item63 => {
      item63.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select) {
      this.select.addEventListener("change", this.handleChange.bind(this));
    }
  }
  handleChange(event3) {
    const param26 = event3.target.value.trim();
    if (event3.target.checkValidity()) {
      this.prevValue = param26;
    } else {
      event3.target.value = this.prevValue;
      return;
    }
    this.productFormInput.value = param26;
    if (this.isRequired && this.isText) {
      this.validateValue(param26, event3.target);
    }
  }
  validateValue(list3, param73) {
    const x25 = list3.length > 0 ? true : false;
    if (x25 === this.isValid) {
      return;
    }
    this.isValid = x25;
    if (param73) {
      if (this.isValid) {
        param73.classList.remove("input--error");
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1;
      } else {
        param73.classList.add("input--error");
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1;
      }
    }
    const param19 = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields;
    const x12 = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach(item54 => {
      if (param19 && !x12) {
        item54.removeAttribute("disabled");
      } else {
        item54.setAttribute("disabled", "");
      }
    });
    if (this.atcErrorMsg.length === 0) {
      return;
    }
    if (param19) {
      this.mainAtcBtnLabel.style.display = "";
      this.mainAtcBtnError.style.display = "none";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "";
        this.stickyAtcBtnError.style.display = "none";
      }
    } else {
      this.mainAtcBtnLabel.style.display = "none";
      this.mainAtcBtnError.style.display = "";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "none";
        this.stickyAtcBtnError.style.display = "";
      }
    }
  }
  createInputs() {
    this.productFormInput = document.createElement("input");
    this.productFormInput.setAttribute("type", "hidden");
    this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]");
    this.productFormInput.value = this.dataset.defaultValue;
    this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);

function playMedia() {
  if (!serial) {
    serial = currentScript.dataset.animationsType || "";
  }
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = "StickyAtcVariantPicker-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = false;
    this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true";
    this.prependMedia = this.dataset.disablePrepend != "true";
    if (this.hasQuantityBreaksPicker) {
      this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle;
      this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages;
    }
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    const items6 = [];
    this.querySelectorAll(".product-form__input").forEach(item25 => {
      let el75;
      const el7 = item25.querySelector(".product-form__input__type").dataset.type;
      if (el7 == "dropdown" || el7 == "dropdwon") {
        el75 = item25.querySelector("select").value;
      } else {
        el75 = item25.querySelector("input[type=\"radio\"]:checked").value;
      }
      items6.push(el75);
    });
    this.options = items6;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(item40 => {
      return !item40.options.map((param38, x67) => {
        return this.options[x67] === param38;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) {
      return;
    }
    if (!this.currentVariant.featured_media) {
      return;
    }
    const nodeList8 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    nodeList8.forEach(item69 => item69.setActiveMedia(this.dataset.section + "-" + this.currentVariant.featured_media.id, this.prependMedia));
    const el54 = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
    if (!el54) {
      return;
    }
    const el50 = el54.querySelector("[data-media-id=\"" + this.currentVariant.featured_media.id + "\"]");
    el54.prepend(el50);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") {
      return;
    }
    window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateShareUrl() {
    const el13 = document.getElementById("Share-" + this.dataset.section);
    if (!el13 || !el13.updateUrl) {
      return;
    }
    el13.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateVariantInput() {
    const nodeList3 = document.querySelectorAll("#product-form-" + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
    nodeList3.forEach(item19 => {
      const el23 = item19.querySelector("input[name=\"id\"]");
      el23.value = this.currentVariant.id;
      el23.dispatchEvent(new Event("change", {
        bubbles: true
      }));
    });
  }
  updateVariantStatuses() {
    const x70 = this.variantData.filter(item17 => this.querySelector(":checked").value === item17.option1);
    const x87 = !this.isSecondary ? [...this.querySelectorAll(".product-form__input")] : [...this.secondarySelect.querySelectorAll(".product-form__input")];
    x87.forEach((param27, x44) => {
      if (x44 === 0) {
        return;
      }
      const param82 = [...param27.querySelectorAll("input[type=\"radio\"], option")];
      const x28 = x87[x44 - 1].querySelector(":checked").value;
      const filtered = x70.filter(item42 => item42.available && item42["option" + x44] === x28).map(item36 => item36["option" + (x44 + 1)]);
      this.setInputAvailability(param82, filtered);
    });
  }
  setInputAvailability(param65, str16) {
    param65.forEach(item31 => {
      if (item31.nodeName === "option") {
        if (str16.includes(item31.getAttribute("value"))) {
          item31.innerText = item31.getAttribute("value");
        } else {
          item31.innerText = window.variantStrings.unavailable_with_option.replace("[value]", item31.getAttribute("value"));
        }
      } else if (str16.includes(item31.getAttribute("value"))) {
        item31.classList.remove("disabled");
      } else {
        item31.classList.add("disabled");
      }
    });
  }
  updatePickupAvailability() {
    const el58 = document.querySelector("pickup-availability");
    if (!el58) {
      return;
    }
    if (this.currentVariant && this.currentVariant.available) {
      el58.fetchAvailability(this.currentVariant.id);
    } else {
      el58.removeAttribute("available");
      el58.innerHTML = "";
    }
  }
  removeErrorMessage() {
    const x116 = this.closest("section");
    if (!x116) {
      return;
    }
    const el44 = x116.querySelector("product-form");
    if (el44) {
      el44.handleErrorMessage();
    }
  }
  renderProductInfo() {
    const x15 = this.currentVariant.id;
    const originalSection = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(this.dataset.url + "?variant=" + x15 + "&section_id=" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(response5 => response5.text()).then(response10 => {
      if (this.currentVariant.id !== x15) {
        return;
      }
      const parser1 = new DOMParser().parseFromString(response10, "text/html");
      const el8 = document.getElementById("price-" + this.dataset.section);
      const el49 = parser1.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const el40 = document.getElementById("sticky-atc-separate-price-" + this.dataset.section);
      const el19 = parser1.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const el57 = document.getElementById("sticky-atc-price-" + this.dataset.section);
      const el78 = parser1.getElementById("sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const el33 = document.getElementById("sticky-atc-image-" + this.dataset.section);
      const x54 = parser1.getElementById("sticky-atc-image-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const el61 = document.getElementById("main-atc-price-" + this.dataset.section);
      const el67 = parser1.getElementById("main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const nodeList26 = document.querySelectorAll("[id^=\"custom-label-" + this.dataset.section + "\"]");
      const nodeList22 = parser1.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + "\"]");
      const el3 = parser1.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const el14 = document.getElementById("Sku-" + this.dataset.section);
      const el15 = parser1.getElementById("Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const el36 = document.getElementById("Inventory-" + this.dataset.section);
      if (el8 && el49) {
        el8.innerHTML = el49.innerHTML;
      }
      if (el40 && el19) {
        el40.innerHTML = el19.innerHTML;
      }
      if (el57 && el78) {
        el57.innerHTML = el78.innerHTML;
      }
      if (el33 && x54) {
        el33.src = x54.src;
      }
      if (el67 && el61) {
        el61.innerHTML = el67.innerHTML;
      }
      if (nodeList26 && nodeList22) {
        for (var counter16 = 0; counter16 < nodeList26.length; counter16++) {
          nodeList26[counter16].innerHTML = nodeList22[counter16].innerHTML;
        }
      }
      if (el15 && el36) {
        el36.innerHTML = el15.innerHTML;
      }
      if (el3 && el14) {
        el14.innerHTML = el3.innerHTML;
        el14.classList.toggle("visibility-hidden", el3.classList.contains("visibility-hidden"));
      }
      if (this.QuantityBreaks) {
        const x75 = parser1.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        const list4 = this.QuantityBreaks.querySelectorAll(".dynamic-price");
        const nodeList18 = x75.querySelectorAll(".dynamic-price");
        for (let counter3 = 0; counter3 < list4.length; counter3++) {
          list4[counter3].innerHTML = nodeList18[counter3].innerHTML;
        }
        if (this.QuantityBreaks.hasVariants) {
          this.QuantityBreaks.variantSelects.forEach(item => {
            item.dataset.selectedId = this.currentVariant.id;
          });
          const list = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select");
          const nodeList4 = x75.querySelectorAll(".quantity-break__variant-select");
          for (let counter20 = 0; counter20 < list.length; counter20++) {
            list[counter20].innerHTML = nodeList4[counter20].innerHTML;
          }
          this.QuantityBreaks.initVariants();
        };
      }
      if (this.hasQuantityBreaksPicker) {
        const x3 = parser1.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        const nodeList6 = this.querySelectorAll(".dynamic-price");
        const nodeList13 = x3.querySelectorAll(".dynamic-price");
        for (let counter7 = 0; counter7 < nodeList6.length; counter7++) {
          nodeList6[counter7].innerHTML = nodeList13[counter7].innerHTML;
        }
        if (this.quantityBreaksPickerStyle === "vertical" && this.quantityBreaksPickerDisplayedImages === "variant_images") {
          const nodeList15 = this.querySelectorAll(".quantity-break__image img");
          const nodeList10 = x3.querySelectorAll(".quantity-break__image img");
          for (let counter10 = 0; counter10 < nodeList15.length; counter10++) {
            nodeList15[counter10].src = nodeList10[counter10].src;
          }
        }
      }
      if (this.secondarySelect) {
        const param9 = parser1.getElementById("" + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        if (param9) {
          this.secondarySelect.innerHTML = param9.innerHTML;
        }
      }
      const el1 = document.getElementById("price-" + this.dataset.section);
      if (el1) {
        el1.classList.remove("visibility-hidden");
      }
      if (el36) {
        el36.classList.toggle("visibility-hidden", el15.innerText === "");
      }
      const x42 = parser1.getElementById("ProductSubmitButton-" + originalSection);
      this.toggleAddButton(x42 ? x42.hasAttribute("disabled") : true, window.variantStrings.soldOut);
      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: originalSection,
          html: parser1,
          variant: this.currentVariant
        }
      });
    });
  }
  toggleAddButton(flag5 = true, param11, flag2 = true) {
    const el42 = document.getElementById("product-form-" + this.dataset.section);
    if (!el42) {
      return;
    }
    const el35 = el42.querySelector("[name=\"add\"]");
    const el53 = el42.querySelector("[name=\"add\"] > .main-atc__label");
    if (!el35) {
      return;
    }
    if (flag5) {
      el35.setAttribute("disabled", "disabled");
      el35.setAttribute("data-unavailable", "true");
      if (param11) {
        el53.textContent = param11;
      }
    } else {
      el35.setAttribute("data-unavailable", "false");
      el53.textContent = window.variantStrings.addToCart;
      if (el35.dataset.requiredFields === el35.dataset.validFields) {
        el35.removeAttribute("disabled");
      }
    }
    if (!flag2) {
      return;
    }
  }
  setUnavailable() {
    const el55 = document.getElementById("product-form-" + this.dataset.section);
    const el59 = el55.querySelector("[name=\"add\"]");
    const el81 = el55.querySelector("[name=\"add\"] > .main-atc__label");
    const el76 = document.getElementById("price-" + this.dataset.section);
    const el69 = document.getElementById("Inventory-" + this.dataset.section);
    const el79 = document.getElementById("Sku-" + this.dataset.section);
    if (!el59) {
      return;
    }
    el81.textContent = window.variantStrings.unavailable;
    if (el76) {
      el76.classList.add("visibility-hidden");
    }
    if (el69) {
      el69.classList.add("visibility-hidden");
    }
    if (el79) {
      el79.classList.add("visibility-hidden");
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);